import { render, staticRenderFns } from "./DraggableProfileCard.vue?vue&type=template&id=39b7c43f&"
import script from "./DraggableProfileCard.vue?vue&type=script&lang=js&"
export * from "./DraggableProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports